
export function NotificationsSound(){
        const audio = new Audio(require("../assets/notification.mp3"));
        audio.play();
}